<select-field 
    [selectFormControl]="selectFormControl" 
    [label]="label" 
    [options]="options" 
    [readonly]="readonly"
/>